import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { buildApiUrl } from '../../config/api';
import './PasswordRecovery.css';
import { Link } from 'react-router-dom';
import { AuthService } from '../../services/AuthService';

const PasswordRecovery = () => {
  const [documentNumber, setDocumentNumber] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaText, setCaptchaText] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  // Generar captcha al montar el componente
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Función para generar captcha aleatorio
  const generateCaptcha = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCaptchaText(result);
  };

  // Enviar solicitud de recuperación
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');

    // Validar documento
    if (!documentNumber.trim()) {
      setMessage("El número de documento es obligatorio");
      setMessageType("error");
      return;
    }

    // Validar captcha
    if (!captchaInput.trim() || captchaInput.toUpperCase() !== captchaText.toUpperCase()) {
      setMessage("El código de seguridad es incorrecto");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const res = await AuthService.recoverPassword(documentNumber);

      if (res.success) {
        setMessage('Se ha enviado una nueva contraseña a su correo electrónico');
        setDocumentNumber("")
        setCaptchaInput("");
        setMessageType('success');
        generateCaptcha();
      } else {
        setMessage(res.message || 'Error al procesar la solicitud');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Error en recuperación de contraseña:', error);
      if (error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage('Error de conexión. Intente nuevamente.');
      }
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-recovery-overlay">
      <div className="password-recovery-modal">
        <div className="recovery-header">
          <h2> Recuperar Contraseña</h2>
          <p>Ingrese su Correo electrónico y número de documento, complete el captcha para recibir una nueva contraseña</p>
        </div>

        <form onSubmit={handleSubmit} className="recovery-form">

          <div className="form-group">
            <label htmlFor="documentNumber">Número de documento:</label>
            <input
              type="text"
              id="documentNumber"
              name="documentNumber"
              value={documentNumber}
              onChange={(e) => setDocumentNumber(e.target.value)}
              placeholder="Ingrese su Número de documento"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="captcha">Código de Seguridad:</label>
            <div className="captcha-container">
              <div className="captcha-display">
                <span className="captcha-text">{captchaText}</span>
                <button
                  type="button"
                  className="refresh-captcha"
                  onClick={generateCaptcha}
                  disabled={loading}
                  title="Generar nuevo código"
                >
                  🔄
                </button>
              </div>
              <input
                type="text"
                id="captcha"
                name="captcha"
                value={captchaInput}
                onChange={(e) => setCaptchaInput(e.target.value)}
                placeholder="Ingrese el código"
                disabled={loading}
                maxLength={6}
                style={{ textTransform: 'uppercase' }}
              />
            </div>
          </div>

          {message && (
            <div className={`message ${messageType}`}>
              {message}
            </div>
          )}

          <div className="recovery-actions">
            <button
              type="submit"
              className="btn-recover"
              disabled={loading}
            >
              {loading ? '⏳ Enviando...' : 'Enviar '}
            </button>

            <Link to="/" className="btn-back" disabled={loading}>
              ← Volver al Login
            </Link>

          </div>
        </form>

      </div>
    </div>
  );
};

export default PasswordRecovery;
